import * as React from "react";

//MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@material-ui/core";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import { animated } from "react-spring";
import clsx from "clsx";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
			alignItems: "center",
			padding: theme.spacing(3),
			flexDirection: "column",
		},
	});

export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {}

const Loader = React.forwardRef<
	HTMLDivElement,
	LoaderProps & WithStyles<typeof styles>
>(({ classes, className, ...divProps }) => {
	return (
		<div className={clsx(classes.root, className)} {...divProps}>
			<CircularProgress />
			<Typography variant="body2" style={{ marginTop: 16 }}>
				Loading...
			</Typography>
		</div>
	);
});

const StyledLoader = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("Loader"),
})(Loader);

export default StyledLoader;

export const AnimatedLoader = animated(StyledLoader);
